import Vue from "vue";
import VueI18n from "vue-i18n";
import ElementUI from "element-ui";
Vue.use(VueI18n);
const messages = {
    'zh-CN': require('./languages/zh-CN').default,
    'zh-TW': require('./languages/zh-TW').default,
    'en': require('./languages/en').default,
    'ja': require('./languages/ja').default,
    'ru': require('./languages/ru').default,
    'es': require('./languages/es').default
};
const i18n = new VueI18n({
    locale: localStorage.getItem('lang') || 'zh-CN',
  messages,
  sync: true
});
Vue.use(ElementUI,{
    i18n: (key, value) => i18n.t(key, value)
});
export default i18n;